<!--  -->
<template>
  <div>
    <div class="task-list">
      <div class="content">
        <div class="section">
          <div class="list" v-for="(item, k) in taskList" :key="k" @click="openTask(item)">
            <img class="icon" :src="item.icon" />
            <div class="desc">
              <h1>{{ item.title }}</h1>
            </div>
            <button class="btn">
              <span v-if="item.id == 1"> {{ doTask.includes(1) ? '已完成' : item.btnTxt }}</span>
              <span v-if="item.id == 2"> {{ doTask.includes(2) ? '已完成' : item.btnTxt }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <SharePop ref="lotteryShare" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import SharePop from './sharePop.vue';
import { reqFlipDoneTaskUrl, reqUsertaskUrl } from '@/api/activity/index';
export default {
  components: {
    SharePop,
  },
  data() {
    return {
      isApp: this.$root.isApp,
      miniprogram: this.$root.miniprogram,
      currentTask: {},
      taskList: [
        {
          id: 1,
          btnTxt: '去浏览',
          title: '浏览课程30秒，获得一次翻牌',
          icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/icon1.png',
        },
        {
          id: 2,
          btnTxt: '去分享',
          title: '分享给好友，获得一次翻牌',
          icon: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/icon2.png',
        },
      ],
      doTask: [],
    };
  },
  props: {
    shareFn: {
      type: Object,
      default: () => { },
    },
    taskFn: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    doTask: {
      deep: true,
      handler() { },
    },
  },
  created() {
    wx.ready(() => {
          // 需在用户可能点击分享按钮前就先调用
          wx.miniProgram.postMessage({
            data: {
              title: '抽卡',
              imageUrl:
                'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/miniShare.png',
              path: `${window.location.origin}${window.location.pathname}`,
            },
          });
        });
   },
  mounted() {
    if (localStorage.getItem('accessToken')) {
      this.getData();
    }

  },
  methods: {
    async getData() {
      let res = await reqUsertaskUrl();
      if (res.code === 0) {
        this.doTask = res.data;
      }
    },
    openTask(item) {
      if (!this.userInfo?.id) {
        this.$emit('taskFn');
        return
      }
      if (item.id === 1) {
        //浏览
        this.openBrowse();
      } else {
        //分享
        this.openShare();
      }
    },

    //分享
    async openShare() {
      this.$refs.lotteryShare.sharePop = true;
      if (!this.doTask.includes(2)) {
        await reqFlipDoneTaskUrl(2);
        this.$emit('shareFn');
        this.getData();
      }
     
    },
    // 浏览
    openBrowse() {
      let query = this.doTask.includes(1) ? '' : '&chouka=1&activetype=1&broswerTime=30';
      this.$router.push({
        path: `/courseDetail?courseId=3684${query}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.task-list {
  padding-top: 1px;
  margin-top:20px;
  background: #f5cacd;

  .content {
    width: 680px;
    height: 450px;
    margin: 0px auto 0;
    padding: 134px 20px 0 20px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/taskbg.png');
    background-size: 100%;

    .section {
      .list {
        display: flex;
        align-items: center;
        height: 124px;
        margin: 0 auto 20px;
        margin-bottom: 20px;
        padding: 0 24px;
        background: linear-gradient(180deg, #fff 0%, #fee5fa 100%);
        border-radius: 26px;
        .icon {
          width: 76px;
          height: 76px;
          margin-right: 12px;
        }

        .desc {
          width: 400px;
          margin-right: 39px;

          h1 {
            width: 100%;
            padding-bottom: 6px;
            overflow: hidden;
            color: #e33c6e;
            font-weight: 500;
            font-size: 24px;
            line-height: 40px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .btn {
          flex-shrink: 0;
          min-width: 109px;
          height: 49px;
          color: #fff;
          font-weight: 500;
          font-size: 24px;
          line-height: 49px;
          background: linear-gradient(90deg, #ff8383 0%, #ff3838 100%);
          border-radius: 24px;

          span {
            display: block;
          }
        }

        .btn.disabled {
          background: #d2dbe5 !important;
        }
      }
    }
  }
}
</style>
